import { render, staticRenderFns } from "./CustomerSessionCard.vue?vue&type=template&id=08227a46&"
import script from "./CustomerSessionCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerSessionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports